const {Component} = require("react");
const PropTypes = require("prop-types");
const Action = require("components/abstract/Action");

class TableHead extends Action {

	/////////////////////////////////
	// Statics
	/////////////////////////////////

	static get propTypes() {
		return {
            descending: PropTypes.bool,
            className: PropTypes.string,
            sortable: PropTypes.bool
		};
    }

    static get defaultProps(){
	    return {
	        alignment: 'left'
        };
    }

	/////////////////////////////////
	// Init
	/////////////////////////////////

    constructor(props){
        super(props);

		this.state = {
            descending: this.props.descending,
            checked: this.props.checked
		};
    }

	/////////////////////////////////
	// Getters
	/////////////////////////////////

    get defaultClassNames() {
    	const {sortable} = this.props;
    	const {descending} = this.state;

    	return [
    		sortable && descending ? 'descending' : null,
    		sortable && !descending ? 'ascending' : null,
    	];
    }

	/////////////////////////////////
	// Event handlers
	/////////////////////////////////

    _onAction = () => {
    	if (!this.props.sortable) return;

		this.setState(
			{descending: !this.state.descending},
			() => this.onAction({slug: this.props.slug, desc: this.state.descending})
		);
    }

	/////////////////////////////////
	// Renders
	/////////////////////////////////

    render(){
        return(
            <th className={this.classNames} onClick={this._onAction} align={this.props.alignment}>
				{this.props.children}
            </th>
        );
    }

}

module.exports = TableHead;
